const homeRouter = [
  {
    // 登录页面
    path: '/index',
    name: 'index',
    component: () => import('@/page/home/index')
  },
  {
    // 事前首页页面
    path: '/beforeIndex',
    name: 'beforeIndex',
    component: () => import('@/page/home/beforeIndex')
  }
]

export default homeRouter



// WEBPACK FOOTER //
// ./src/router/modules/home.js